import React from 'react';
import Icon from 'kingpin/atoms/Icon';

interface Props {
  isOpen?: boolean;
}

const PopUpMenuChevron = ({ isOpen }: Props) => {
  return (
    <Icon
      icon="chevron-down"
      width={16}
      height={16}
      style={{
        marginLeft: 'auto',
        transition: 'transform 200ms ease',
        transform: `rotate(${isOpen ? '180deg' : '0deg'})`,
        color: 'grey',
      }}
    />
  );
};

export default PopUpMenuChevron;
